import { render, staticRenderFns } from "./boxToColumn.vue?vue&type=template&id=70faa09e&"
import script from "./boxToColumn.vue?vue&type=script&lang=js&"
export * from "./boxToColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports